import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Login() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/";

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState("");

    const onSubmit = async (e) => {
        e.preventDefault();
        setErr("");
        setBusy(true);
        try {
            await login(email.trim(), password);
            localStorage.setItem("trader_id", email.trim());
            navigate(from, { replace: true });
        } catch (e2) {
            setErr("Invalid email or password.");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="w-full flex items-center justify-center p-6">
            <form onSubmit={onSubmit} className="w-full max-w-sm bg-gray-800 border border-gray-700 rounded-2xl p-6 space-y-4">
                <h1 className="text-2xl font-bold text-blue-400">Sign in</h1>

                <label className="block text-sm">
                    <span className="text-gray-300">Email</span>
                    <input
                        type="email"
                        className="mt-1 w-full bg-gray-900 border border-gray-700 rounded px-3 py-2"
                        value={email} onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                </label>

                <label className="block text-sm">
                    <span className="text-gray-300">Password</span>
                    <input
                        type="password"
                        className="mt-1 w-full bg-gray-900 border border-gray-700 rounded px-3 py-2"
                        value={password} onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                </label>

                {err && <div className="text-red-400 text-sm">{err}</div>}

                <button
                    type="submit"
                    disabled={busy}
                    className={`w-full py-2 rounded-xl font-semibold ${busy ? "bg-gray-600" : "bg-blue-600 hover:bg-blue-500"}`}
                >
                    {busy ? "Signing in�" : "Sign in"}
                </button>

                <div className="text-sm text-gray-400">
                    No account? <Link to="/register" className="text-blue-400 hover:underline">Create one</Link>
                </div>

                <Link to="/forgot" className="text-blue-400 hover:underline text-sm">Forgot your password?</Link>
            </form>
        </div>
    );
}
